/* Maintenance.js */

import React from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import Strings from '../../translations/Translations';

export default function Maintenance() {
  const maintenanceMessage = (document.APPLICATION_MAINTENANCE_MESSAGE) ? document.APPLICATION_MAINTENANCE_MESSAGE : Strings('maintenance_default_message');

  return (
    <div className='pb-bg-1'>
      <Container>
        <Row className='login-page justify-content-center align-items-center'>
          <Col md={6}>
            <Card className='p-2 shadow text-center'>
              <CardBody>
                <div className='mb-4'>
                  <h1 className="h2 modal-title">{Strings('application_title')}</h1>
                </div>
                
                <div className='mb-5'>
                  <h6 className="opacity-8">{maintenanceMessage}</h6>
                </div>

                <div className="opacity-8">
                  Copyright &copy; Photozig Inc.
                </div>
              </CardBody>
              
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
